import { SitesBuilderLibComponent, Copylink } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-copylink',
  templateUrl: './copylink.component.html',
  styleUrls: ['./copylink.component.scss']
})
export class CopylinkComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Copylink;
  @Output() exportTool = new EventEmitter<Copylink>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.copylink){
        this.tool = JSON.parse(JSON.stringify(res.copylink));
      }else{
        console.error("Copy Link tool not found");
        return;
      }
    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

}
